import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

/**
 * Modificación de un agente. Se manda id + versión + SOLO lo que cambió.
 *
 * Todo va con `|| null` y nunca con `|| ''`, y eso es el contrato, no una preferencia:
 * para este servicio `null` significa "no cambiar" y la cadena vacía se GRABA tal cual.
 * Con `''` cada llamada pisaba con vacío todo campo que el formulario no tocara, y por
 * eso los modales tenían que reenviar valores que no estaban editando.
 *
 * La VERSION va con `??`: la de un registro recién creado es 0 y `||` la mandaría null.
 *
 * Lo que este servicio NO manda, a propósito:
 *   - documento, sexo y fecha de nacimiento: no se modifican, y si viajan tienen que
 *     coincidir con el vínculo o devuelven 41031.
 *   - `rnhFuncionCod`: la función dejó de ser del agente y pasó a ser del LUGAR. Se
 *     edita con RNHAgenteAsignarDo, no acá.
 */
export const RNHAgenteUpd = async (credentials, data) => {
  const body = {
    service: "RNHAgenteUpd",
    params: {
      // Obligatorios: sin ellos, 41003 y 41004.
      rnhAgenteId: data?.agenteId || null,
      rnhAgenteVersion: data?.version ?? null,

      // Datos del vínculo.
      usuarioApellidos: data?.apellidos || null,
      usuarioNombres: data?.nombres || null,
      usuarioMail: data?.mail || null,

      // Datos del agente.
      rnhAgenteLegajo: data?.legajo || null,
      rnhAgenteFechaInicio: data?.fechaInicio || null,
      rnhCargoCod: data?.cargoCod || null,
      rnhConvenioCod: data?.convenioCod || null,
      // F (fijo) o R (rotativo). Como todo en este servicio, null es "no cambiar": desde
      // el modal se puede pasar de F a R, pero no volver a "sin asignar".
      rnhAgenteHorarioTipo: data?.horarioTipo || null,
      rnhHospitalCod: data?.hospitalCod || null,
      rnhAgenteEstablecimientoUnico: data?.esUnico || null,

      // Si cambia el título, la matrícula tiene que viajar en la MISMA llamada (41025).
      // Una matrícula sin título se rechaza (41021).
      rnhTituloCod: data?.tituloCod || null,
      rnhAgenteMatricula: data?.matricula || null,

      // Estado del VINCULO: A, B o S. "B" da de baja y le quita todos los lugares.
      rnhStatusAgenteCod: data?.statusCod || null,
    }
  }

  return respuestaDe(await axiosPost(body, credentials));
}
